  // if ($(window).width() > 1024) {

  //   $(".js-services-list-item.has-submenu .main-nav__link").on('click', function(event) {

  //     event.preventDefault();



  //     var $parent = $(this).closest('.js-services-list-item');

  //     showMenuDesk($parent, event);


  //     if (!$(this).is('.is-clicked') && $parent.is('.is-opened')) {
  //       event.preventDefault();
  //     }

  //     $(this).addClass('is-clicked');

  //   });

  // }



  function mainNav() {


    // iOS detect
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (iOS) {
      $('body').addClass('isIos');
    }

    /*Скрытие активного контентного меню при скролле или ресайзе окна*/
    $(window).on("resize", function() {
      hideOpened();
    })
    /*Скрытие по нажатию на область документа.*/
    $(window).on("click", function(e) {
      if (!isOnSubcontent($(e.target)) &&
        !$(e.target).parents().hasClass("js-services-list-item")) {
        hideOpened()
      }
    })

    function isOnSubcontent(obj) {
      return obj.parents().hasClass("subcontent")
    }


    /*Ховер на элементы с обычными подменюшками*/
    $(".submenu").each(function() {
      /*set submenu postition*/
      var submenu = $(this);
      var cont = $(this).parents(".js-services-list-item");
      var contList = $(this).parents(".js-services-list");
      var vw = $(window).width();
      submenu.addClass('subcontent');
    });


    var mainMenuClickFlag = false;

    /*Ховер на подменюшки с контентом*/

      // $(".js-services-list-item").hover(
      //    function (e) {
      //      showMenuDesk($(this), e);
      //    },
      //    function (e) {
      //      hideOpened();
      //      $("body").removeClass("no-overflow");
      //      $("body").css({"padding-right": "0"});
      //    }
      //  );

      $(".js-services-list-item.has-submenu .main-nav__link").on('click', function(event) {
          if ($(window).width() > 1024) {
                var $parent = $(this).closest('.js-services-list-item');
                showMenuDesk($parent, event);

                if (!$(this).is('.is-clicked') && $parent.is('.is-opened')) {
                  event.preventDefault();
                }

                $(this).addClass('is-clicked');
          }
      });






    $(".js-services-list-item").on("click", function(e) {
      var vw = $(window).width();
      var contList = $(this).parents(".js-services-list");
     /* if (vw < 768) {
        var ifcarCard = ($(e.target).hasClass("car-card") || $(e.target).parent().hasClass("car-card"))
        if ($(this).hasClass("has-submenu") && !($(e.target).hasClass("submenu__link")) && !ifcarCard) {
          e.preventDefault();
          openSubcontent($(this), contList)
        }
      }*/
      if (vw >= 768 && vw <= 1024) {
        showMenuDesk($(this), e);

      }
    })

    function showMenuDesk(obj, e) {
      var vw = $(window).width();
      var scrollbarWidth = window.innerWidth - document.body.clientWidth;
      var subcontent = obj.find('.subcontent');
      var contList = obj.parents(".js-services-list");
      var headerHeight = $(".header").outerHeight();
      var bottomHeaderHeight = $('.header__bottom').outerHeight();
      /*mobile handle*/

      var submenu = obj.find(".submenu");
      if (vw >= 768 && vw <= 1024) {
        var ifcarCard = ($(e.target).hasClass("car-card") || $(e.target).parent().hasClass("car-card"))
        if (obj.hasClass("has-submenu") && !($(e.target).hasClass("submenu__link")) && !ifcarCard) {
          e.preventDefault();
        }
      }
      if (!obj.hasClass("is-opened") && subcontent.length) {
        hideOpened();
        obj.addClass("is-opened");
        subcontent.fadeIn();
        $("body").addClass("no-overflow");
        $("body").css({ "padding-right": scrollbarWidth + "px" });

        //var subcontentPosition = $('.header__bottom').hasClass('_fixed') ? bottomHeaderHeight : headerHeight;
        var subcontentPosition = bottomHeaderHeight;
        subcontent.css({
          "top": `${subcontentPosition}px`
        });
        /*Запуск загрузки списка машин для первого
          в списке элемента (дефолтного)*/
        /*if (subcontent.find(".js-get-cars-list").length) {
          subcontent.find(".js-get-cars-list").eq(0).trigger("click");
        } else if (subcontent.parent().find(".js-get-cars-list") && vw > 1024) {
          subcontent.parent().find(".js-get-cars-list").trigger("click");
        }*/
      } else if (!isOnSubcontent($(e.target))) {
        hideOpened();
        $("body").removeClass("no-overflow");
        $("body").css({ "padding-right": "0" });

      }

      if (submenu.length) {
        var cont = submenu.parents(".js-services-list-item");
        submenuPosition(submenu, cont);
        submenu.fadeIn("fast");
      }
    }


  $(".subcontent .close").on("click", function (e) {
      $(".js-fader").fadeOut("300");
      $("body").removeClass("no-overflow");
      hideOpened();
      e.stopPropagation();
  });


    $(document).on("click", ".js-services-list-item a.car-card", function(e) {
      e.stopPropagation();
    })

    var menuPos = $('.header__bottom').offset().top;
    var docPos = $(document).scrollTop();

    $(document).on('scroll', function() {
      var headerHeight = $(".header").outerHeight();
      var bottomHeaderHeight = $('.header__bottom').outerHeight();
      var subcontent = $('.subcontent');

      docPos = $(document).scrollTop();
      if ($(window).width() >= 768) {
        if (docPos >= menuPos) {
          $('.header__top, .header__bottom').addClass('_fixed');
          subcontent.css({ "top": `${bottomHeaderHeight}px` })
        } else {
          $('.header__top, .header__bottom').removeClass('_fixed');
          subcontent.css({ "top": `${headerHeight}px` })
        }
      }
    });

    function openSubcontent(cont, contList) {
      var subcontent = cont.find(".subcontent");
      var bottomInfo = $(".main-nav__menu-bottom");
      var screenHeight = $(window).outerHeight();
      var scrollcont = subcontent.find(".js-scrollable");
      var backLink = subcontent.find(".js-mob-back");

      contList.css({
        "transform": "translateX(-100%)"
      })

      if (scrollcont.length) {
        scrollable(scrollcont);
      }

      bottomInfo.fadeOut();
      subcontent.fadeIn();
      subcontent.css({
        "transform": "translateX(100%)"
      });
      backLink.on("click", function(e) {
        closeSubcontent(cont, contList)
      });
    }

    function closeSubcontent(cont, contList) {

      var subcontent = cont.find(".subcontent")
      var bottomInfo = $(".main-nav__menu-bottom");
      subcontent.fadeOut();
      subcontent.css({
        "transform": "translateX(200%)"
      })
      bottomInfo.fadeIn();
      contList.css({
        "transform": "translateX(0)"
      })
      cont.off("click");
      setTimeout(function() {
        cont.on("click", function(e) {
          e.preventDefault();
          openSubcontent($(this), contList)
        })
      }, 0)
    }

    function hideOpened() {
      $(".is-opened").each(function() {
        $(this).find(".subcontent").fadeOut();
        $(this).removeClass("is-opened");
        $(this).find('.is-clicked').removeClass('is-clicked');

      })
    }

    function submenuPosition(submenu, cont) {
      var contLeft = cont.offset().left;
      var contWidth = cont.width();
      var headerHeight = $(".header").outerHeight();
      var contHeight = cont.parent().outerHeight();
      submenu.css({
        "left": `${contLeft}px`,
        "min-width": `${contWidth}px`,
        "top": `${headerHeight - contHeight/2}px`
      })
    }

    $('.js-mob-showmore').on('click', function(event) {
      event.stopPropagation();
    });
  }
